<template>
<md-card>
    <header-form title="CADASTRAR MOTORISTAS" :rota="{name: 'motoristasRead'}" tooltip="Lista de Motoristas" />

    <form @submit.prevent="create">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-35 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.cpf }">
                        <label>CPF</label> 
                        <md-input v-model="dados.cpf" type="text" v-mask="['###.###.###-##']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.cpf">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.cpf" class="validErro"> {{ errors.cpf[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.celular }">
                        <label>CELULAR</label>
                        <md-input v-model="dados.celular" type="text" v-mask="['(##) ####-####','(##) #####-####']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.celular">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.celular" class="validErro"> {{ errors.celular[0] }}</div>
                </div>

                <div class="md-layout-item md-size-30 md-xsmall-size-100">
                    <md-autocomplete :class="{ 'md-error': errors.empresa_id }" v-model="empresa" :md-options="empresas" @md-changed="autoCompleteEmpresa" @md-opened="autoCompleteEmpresa" @md-selected="getSelectedEmpresa">
                        <label>EMPRESA</label>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.empresa_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-autocomplete>
                    <div v-if="errors.empresa_id" class="validErro"> {{ errors.empresa_id[0] }}</div>
                </div>
            </div>

        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {},
            errors: {},
            listEmpresas: [],
            empresas: ['X'],
            empresa: '',
        }
    },

    created() {
        this.getLista();
    },

    
    watch: {
        empresa: function (value) {
            if (value == null || value == '') {
                this.dados.empresa_id = null
            }
        },
    },

    mixins: [Notify],

    methods: {

        getLista() {
            this.$http.get(this.$urlAPI + 'motoristas')
                .then(response => {
                    this.listEmpresas = response.data.dados.empresa
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        autoCompleteEmpresa(searchTerm) {
            this.empresas = new Promise(resolve => {
                if (!searchTerm) {
                    resolve(this.listEmpresas.map(x => x.name));
                } else {
                    const term = searchTerm.toLowerCase();
                    this.empresas = this.listEmpresas.filter(({
                        name
                    }) => {
                        return name.toLowerCase().includes(term);
                    }).map(x => x.name);
                    resolve(this.empresas);
                }
            });
        },

        getSelectedEmpresa() {
            let customer = this.empresa
            this.dados.empresa_id = this.listEmpresas.filter(function (e) {
                return e.name === customer
            })[0].id
        },

        create() {
            this.$http.post(this.$urlAPI + 'motoristas', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'motoristasRead'
                        })
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>
